"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[746],{

/***/ 7100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ev": function() { return /* binding */ OTP_DIGITS; },
/* harmony export */   "Gb": function() { return /* binding */ LIST_ERRORS_TYPE; },
/* harmony export */   "Gs": function() { return /* binding */ TIMER_RESEND_OTP; },
/* harmony export */   "Hj": function() { return /* binding */ PLACEHOLDERS; },
/* harmony export */   "Ju": function() { return /* binding */ SIGN_UP_OTP_LENGTH; },
/* harmony export */   "K0": function() { return /* binding */ BUSINESS_TYPE; },
/* harmony export */   "L": function() { return /* binding */ BusinessTypeKey; },
/* harmony export */   "Ml": function() { return /* binding */ LIST_PLACEHOLDER; },
/* harmony export */   "Oz": function() { return /* binding */ RegisterFormEnum; },
/* harmony export */   "T7": function() { return /* binding */ SIGN_IN_STEPS; },
/* harmony export */   "Ut": function() { return /* binding */ DEFAULT_VALUE_FORM; },
/* harmony export */   "VL": function() { return /* binding */ onSplitErrorMessage; },
/* harmony export */   "X3": function() { return /* binding */ OTPEnum; },
/* harmony export */   "Zn": function() { return /* binding */ ReferrerPhoneOrCodeError; },
/* harmony export */   "_U": function() { return /* binding */ mappingRegisterFormValues; },
/* harmony export */   "eE": function() { return /* binding */ REFER_CODE_KIOTVIET; },
/* harmony export */   "ec": function() { return /* binding */ getTimeDifferenceInSeconds; },
/* harmony export */   "n": function() { return /* binding */ DEFAULT_ADDRESS; },
/* harmony export */   "nZ": function() { return /* binding */ objectToQueryString; },
/* harmony export */   "tL": function() { return /* binding */ ADDRESS_SERVICE_PROPS; },
/* harmony export */   "y5": function() { return /* binding */ selectMenuProps; },
/* harmony export */   "yM": function() { return /* binding */ PARTNER_NAME_KIOTVIET; },
/* harmony export */   "yO": function() { return /* binding */ LIST_ERRORS_CONTENT; },
/* harmony export */   "zR": function() { return /* binding */ PhoneNumberErrors; }
/* harmony export */ });
/* unused harmony exports ChannelType, ErrorKeys, OTP_ERRORS, REMOVE_KEY_CODES */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71569);



var objectToQueryString = function(obj) {
    var params = new URLSearchParams();
    var objKeys = Object.keys(obj);
    objKeys.forEach(function(key) {
        if (obj[key]) {
            params.append(key, obj[key]);
        }
    });
    return params.toString();
};
var onSplitErrorMessage = function(errorMessage) {
    var parts = errorMessage.split(".");
    var formattedMessage = parts.join(".\n");
    return formattedMessage;
};
var getTimeDifferenceInSeconds = function(expiredTime, nowTime) {
    return Math.round((expiredTime.getTime() - nowTime.getTime()) / 1000);
};
var PLACEHOLDERS;
(function(PLACEHOLDERS) {
    PLACEHOLDERS["businessType"] = "H\xecnh thức kinh doanh l\xe0 *";
    PLACEHOLDERS["businessName"] = "T\xean hộ kinh doanh/doanh nghiệp *";
    PLACEHOLDERS["address"] = "Địa chỉ cụ thể *";
    PLACEHOLDERS["phoneNumber"] = "Nhập số điện thoại *";
    PLACEHOLDERS["email"] = "Nhập email";
    PLACEHOLDERS["referrerPhoneOrCode"] = "Nhập SĐT người giới thiệu hoặc m\xe3";
    PLACEHOLDERS["taxCode"] = "M\xe3 số thuế/Căn cước c\xf4ng d\xe2n *";
})(PLACEHOLDERS || (PLACEHOLDERS = {}));
var BusinessTypeKey;
(function(BusinessTypeKey) {
    BusinessTypeKey["DRUGSTORE"] = "DRUGSTORE";
    BusinessTypeKey["PHARMACY"] = "PHARMACY";
    BusinessTypeKey["CLINIC"] = "CLINIC";
    BusinessTypeKey["HOSPITAL"] = "HOSPITAL";
    BusinessTypeKey["PHARMA_COMPANY"] = "PHARMA_COMPANY";
    BusinessTypeKey["DENTISTRY"] = "DENTISTRY";
    BusinessTypeKey["BEAUTY_SALON"] = "BEAUTY_SALON";
    BusinessTypeKey["HEALTH_CENTER"] = "HEALTH_CENTER";
    BusinessTypeKey["PATIENT"] = "PATIENT";
    BusinessTypeKey["MEDICAL_SUPPLY_STORE"] = "MEDICAL_SUPPLY_STORE";
    BusinessTypeKey["TRADITIONAL_MEDICINE_STORE"] = "TRADITIONAL_MEDICINE_STORE";
})(BusinessTypeKey || (BusinessTypeKey = {}));
var ChannelType;
(function(ChannelType) {
    ChannelType["UTM"] = "UTM";
    ChannelType["Organic"] = "Organic";
})(ChannelType || (ChannelType = {}));
var BUSINESS_TYPE = constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_SCOPE_LABEL */ .xZ;
var RegisterFormEnum;
(function(RegisterFormEnum) {
    RegisterFormEnum["BusinessType"] = "businessType";
    RegisterFormEnum["BusinessName"] = "businessName";
    RegisterFormEnum["TaxCode"] = "taxCode";
    RegisterFormEnum["Address"] = "address";
    RegisterFormEnum["Province"] = "province";
    RegisterFormEnum["District"] = "district";
    RegisterFormEnum["Ward"] = "ward";
    RegisterFormEnum["PhoneNumber"] = "phoneNumber";
    RegisterFormEnum["Email"] = "email";
    RegisterFormEnum["ReferrerPhoneOrCode"] = "referrerPhoneOrCode";
    RegisterFormEnum["TermsOfServiceAccepted"] = "termsOfServiceAccepted";
    RegisterFormEnum["Digit1"] = "digit1";
    RegisterFormEnum["Digit2"] = "digit2";
    RegisterFormEnum["Digit3"] = "digit3";
    RegisterFormEnum["Digit4"] = "digit4";
    RegisterFormEnum["SecretKey"] = "secretKey";
    RegisterFormEnum["identityId"] = "identityId";
    RegisterFormEnum["PartnerName"] = "partnerName";
})(RegisterFormEnum || (RegisterFormEnum = {}));
var SIGN_IN_STEPS;
(function(SIGN_IN_STEPS) {
    SIGN_IN_STEPS[SIGN_IN_STEPS["information"] = 0] = "information";
    SIGN_IN_STEPS[SIGN_IN_STEPS["otp"] = 1] = "otp";
})(SIGN_IN_STEPS || (SIGN_IN_STEPS = {}));
var OTPEnum;
(function(OTPEnum) {
    OTPEnum["Digit1"] = "digit1";
    OTPEnum["Digit2"] = "digit2";
    OTPEnum["Digit3"] = "digit3";
    OTPEnum["Digit4"] = "digit4";
})(OTPEnum || (OTPEnum = {}));
var PhoneNumberErrors;
(function(PhoneNumberErrors) {
    PhoneNumberErrors[PhoneNumberErrors["PHONE_EXISTED"] = 1] = "PHONE_EXISTED";
    PhoneNumberErrors[PhoneNumberErrors["CUSTOMER_EXISTED"] = 2] = "CUSTOMER_EXISTED";
})(PhoneNumberErrors || (PhoneNumberErrors = {}));
var ReferrerPhoneOrCodeError;
(function(ReferrerPhoneOrCodeError) {
    ReferrerPhoneOrCodeError[ReferrerPhoneOrCodeError["FRIEND_NOT_ACTIVE"] = 1] = "FRIEND_NOT_ACTIVE";
    ReferrerPhoneOrCodeError[ReferrerPhoneOrCodeError["REFER_PHONE_INVALID"] = 2] = "REFER_PHONE_INVALID";
    ReferrerPhoneOrCodeError[ReferrerPhoneOrCodeError["REFER_CODE_NOT_EXIST"] = 3] = "REFER_CODE_NOT_EXIST";
})(ReferrerPhoneOrCodeError || (ReferrerPhoneOrCodeError = {}));
var OTP_DIGITS = [
    OTPEnum.Digit1,
    OTPEnum.Digit2,
    OTPEnum.Digit3,
    OTPEnum.Digit4
];
var DEFAULT_VALUE_FORM = {
    businessName: "",
    businessType: "",
    taxCode: "",
    address: "",
    district: "",
    phoneNumber: "",
    email: "",
    province: "",
    referrerPhoneOrCode: "",
    leadSource: "",
    otherSourceDetail: "",
    termsOfServiceAccepted: false,
    ward: "",
    verificationCode: "",
    secretKey: ""
};
var LIST_ERRORS_TYPE = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .ENUMS_ERROR_ACC_CODE */ .E8), {
    ROOT: "root.serverError",
    TOO_MANY_VERIFICATION_CODE_REQUESTS: "TOO_MANY_VERIFICATION_CODE_REQUESTS",
    PHONE_EXISTED: "PHONE_EXISTED",
    REFER_PHONE_INVALID: "REFER_PHONE_INVALID",
    REFER_CODE_NOT_EXIST: "REFER_CODE_NOT_EXIST",
    FRIEND_NOT_ACTIVE: "FRIEND_NOT_ACTIVE"
});
var ErrorKeys;
(function(ErrorKeys) {
    ErrorKeys["NOT_FOUND"] = "NOT_FOUND";
    ErrorKeys["TOO_MANY_OTP_REQUESTS"] = "TOO_MANY_OTP_REQUESTS";
    ErrorKeys["NOT_FOUND_OTP"] = "NOT_FOUND_OTP";
    ErrorKeys["EXPIRED_OTP"] = "EXPIRED_OTP";
    ErrorKeys["EXPIRED_VERIFICATION_CODE"] = "EXPIRED_VERIFICATION_CODE";
    ErrorKeys["INVALID"] = "INVALID";
    ErrorKeys["TOO_MANY_VERIFICATION_CODE_REQUESTS"] = "TOO_MANY_VERIFICATION_CODE_REQUESTS";
    ErrorKeys["USED_OTP"] = "USED_OTP";
    ErrorKeys["INVALID_CUSTOMER_STATUS"] = "INVALID_CUSTOMER_STATUS";
    ErrorKeys["INACTIVE_ACCOUNT"] = "INACTIVE_ACCOUNT";
    ErrorKeys["CUSTOMER_EXISTED"] = "CUSTOMER_EXISTED";
    ErrorKeys["NOT_FOUND_VERIFICATION_CODE"] = "NOT_FOUND_VERIFICATION_CODE";
    ErrorKeys["PHONE_EXISTED"] = "PHONE_EXISTED";
    ErrorKeys["REFER_PHONE_INVALID"] = "REFER_PHONE_INVALID";
    ErrorKeys["REFER_CODE_NOT_EXIST"] = "REFER_CODE_NOT_EXIST";
    ErrorKeys["FRIEND_NOT_ACTIVE"] = "FRIEND_NOT_ACTIVE";
})(ErrorKeys || (ErrorKeys = {}));
var OTP_ERRORS = (/* unused pure expression or super */ null && ([
    "TOO_MANY_VERIFICATION_CODE_REQUESTS",
    "NOT_FOUND_VERIFICATION_CODE"
]));
var LIST_ERRORS_CONTENT = {
    EXPIRED_OTP: "M\xe3 x\xe1c thực đ\xe3 hết hiệu lực. Vui l\xf2ng nhập m\xe3 mới",
    TOO_MANY_VERIFICATION_CODE_REQUESTS: "Bạn đ\xe3 gửi qu\xe1 nhiều y\xeau cầu. Vui l\xf2ng thử lại sau 3 ph\xfat",
    // FALLBACK: Keep this for backward compatibility when dynamic parsing doesn't match
    // The dynamic parsing in handleErrorInformation handles email vs phone number distinction, but this serves as fallback
    // for cases where the error message doesn't contain "email" or "phone number" keywords
    CUSTOMER_EXISTED: " Số điện thoại/Email n\xe0y đ\xe3 được đăng k\xfd",
    NOT_FOUND_VERIFICATION_CODE: "M\xe3 x\xe1c thực kh\xf4ng đ\xfang. Vui l\xf2ng kiểm tra v\xe0 nhập lại!",
    PHONE_EXISTED: " Số điện thoại n\xe0y đ\xe3 được đăng k\xfd!",
    REFER_PHONE_INVALID: "M\xe3 giới thiệu kh\xf4ng hợp lệ",
    REFER_CODE_NOT_EXIST: "SĐT hoặc m\xe3 giới thiệu kh\xf4ng hợp lệ",
    FRIEND_NOT_ACTIVE: "M\xe3 giới thiệu kh\xf4ng hợp lệ",
    NOT_FOUND: "M\xe3 x\xe1c thực kh\xf4ng đ\xfang. Vui l\xf2ng kiểm tra v\xe0 nhập lại!",
    NOT_FOUND_OTP: "M\xe3 x\xe1c thực kh\xf4ng đ\xfang. Vui l\xf2ng kiểm tra v\xe0 nhập lại!",
    EXPIRED_VERIFICATION_CODE: "M\xe3 x\xe1c thực đ\xe3 hết hiệu lực. Vui l\xf2ng nhập m\xe3 mới",
    INVALID: "Bạn đ\xe3 đăng k\xfd qu\xe1 nhiều t\xe0i khoản. Vui l\xf2ng thử lại sau.",
    TOO_MANY_OTP_REQUESTS: "Bạn đ\xe3 gửi qu\xe1 nhiều y\xeau cầu. Vui l\xf2ng thử lại sau 3 ph\xfat",
    USED_OTP: "M\xe3 x\xe1c thực kh\xf4ng đ\xfang. Vui l\xf2ng kiểm tra v\xe0 nhập lại!",
    INVALID_CUSTOMER_STATUS: "T\xe0i khoản của bạn đang tạm ngưng hoạt động.",
    INACTIVE_ACCOUNT: "T\xe0i khoản của bạn đang tạm ngưng hoạt động."
};
var DEFAULT_ADDRESS = {
    label: "",
    value: "",
    regionCode: ""
};
var SIGN_UP_OTP_LENGTH = 4;
var LIST_PLACEHOLDER = {
    province: "Tỉnh/Th\xe0nh Phố *",
    district: "Quận/Huyện *",
    ward: "Phường/X\xe3 *"
};
var selectMenuProps = {
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "left"
    },
    getContentAnchorEl: null,
    PaperProps: {
        style: {
            marginTop: 5,
            marginLeft: 0,
            padding: 20,
            width: 200
        }
    }
};
var ADDRESS_SERVICE_PROPS = {
    isAuth: false,
    isBasic: true
};
var TIMER_RESEND_OTP = 180;
var REMOVE_KEY_CODES = {
    "8": "Backspace",
    "46": "Delete"
};
var mappingRegisterFormValues = function(values) {
    var _verificationCode = values.verificationCode, verificationCode = _verificationCode === void 0 ? "" : _verificationCode, _businessType = values.businessType, businessType = _businessType === void 0 ? "" : _businessType, _businessName = values.businessName, businessName = _businessName === void 0 ? "" : _businessName, _taxCode = values.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode, _address = values.address, address = _address === void 0 ? "" : _address, _province = values.province, province = _province === void 0 ? "" : _province, _ward = values.ward, ward = _ward === void 0 ? "" : _ward, _phoneNumber = values.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "" : _phoneNumber, _email = values.email, email = _email === void 0 ? "" : _email, _district = values.district, district = _district === void 0 ? "" : _district, _referrerPhoneOrCode = values.referrerPhoneOrCode, referrerPhoneOrCode = _referrerPhoneOrCode === void 0 ? "" : _referrerPhoneOrCode, _leadSource = values.leadSource, leadSource = _leadSource === void 0 ? "" : _leadSource, _otherSourceDetail = values.otherSourceDetail, otherSourceDetail = _otherSourceDetail === void 0 ? "" : _otherSourceDetail, _secretKey = values.secretKey, secretKey = _secretKey === void 0 ? "" : _secretKey, _identityId = values.identityId, identityId = _identityId === void 0 ? "" : _identityId, _partnerName = values.partnerName, partnerName = _partnerName === void 0 ? "" : _partnerName;
    var formData = {
        scope: businessType,
        businessName: businessName,
        taxCode: taxCode.trim(),
        address: address,
        provinceCode: province,
        districtCode: district,
        wardCode: ward,
        phone: phoneNumber,
        email: email,
        referCode: referrerPhoneOrCode,
        leadSource: leadSource,
        otherSourceDetail: otherSourceDetail,
        registerURL:  true ? window.location.href : 0,
        isNewFlow: true,
        verificationCode: verificationCode,
        secretKey: secretKey,
        identityId: identityId,
        partnerName: partnerName
    };
    return formData;
};
var REFER_CODE_KIOTVIET = "KIOTVIET";
var PARTNER_NAME_KIOTVIET = "kiotviet";


/***/ }),

/***/ 76412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ek": function() { return /* binding */ ENUM_PRODUCT_TYPE; },
/* harmony export */   "jj": function() { return /* binding */ ENUM_SELLER_TYPE; },
/* harmony export */   "wf": function() { return /* binding */ ACCOUNTS_TRIAL; }
/* harmony export */ });
/* unused harmony exports HOME_MENUS, LINK_DIRECT_TO_MESSENGER, MENUS_USER_INFO, MENUS_UTIL, MENUS_SUPPORT, TagCode, tagList */
/* harmony import */ var constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(199);


var HOME_MENUS = [
    {
        name: "Sản Phẩm",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCTS_LOADING_URL */ .iB,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_ICON */ .dU,
        id: 1
    },
    {
        name: "Khuyến M\xe3i",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_1__/* .KHUYEN_MAI */ .ab,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .DAILY_PROMOTION_ICON */ .LM,
        id: 2
    },
    {
        name: "M\xe3 Giảm Gi\xe1",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_1__/* .PROMO_CODES */ .Q2,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .COUPON_ICON */ .PL,
        id: 3
    }, 
];
var LINK_DIRECT_TO_MESSENGER = "https://m.me/thuocsivn";
var MENUS_USER_INFO = [
    {
        name: "Th\xf4ng tin t\xe0i khoản",
        href: "/my-account",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE_USER_ICON */ .qe
    },
    // {
    //   name: 'Thông tin cấp bậc',
    //   href: '',
    //   srcIcon: LEVEL_ICON,
    // },
    {
        name: "Th\xf4ng tin doanh nghiệp",
        href: "/user/business-information",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .BUSINESS_ICON */ .zG
    }, 
];
var MENUS_UTIL = [
    {
        name: "Đơn h\xe0ng của t\xf4i",
        href: "/my-order",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_ICON */ .Ln
    },
    {
        name: "Tra cứu vận đơn",
        href: "/tracking-order",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .TRUCK_ICON */ .rx
    },
    // {
    //   name: 'Thông tin xuất hóa đơn',
    //   href: '/productviewed',
    //   srcIcon: DOCUMENT_ICON2,
    // },
    {
        name: "Thống k\xea đơn h\xe0ng",
        href: "/user/dashboard",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .INSIGHT_ICON */ .hr
    },
    {
        name: "Sản phẩm đ\xe3 xem",
        href: "/productviewed",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .M_EYE_ICON */ .C6
    },
    {
        name: "Giới thiệu bạn b\xe8",
        href: "/users/referrals",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .INFO_ICON */ .lS
    },
    {
        name: "M\xe3 giảm gi\xe1 của t\xf4i",
        href: constants_Paths__WEBPACK_IMPORTED_MODULE_1__/* .USER_PROMO_CODES_URL */ .Py,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE_VOUCHER_ICON */ .He
    },
    {
        name: "Sản phẩm quan t\xe2m",
        href: "/user/wishlist",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .HEART_ICON */ .Un
    },
    {
        name: "Tra cứu th\xf4ng tin sản phẩm",
        href: "/qr",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .RESEARCH_INFO_ICON */ .x7
    },
    {
        name: "Phản hồi của t\xf4i",
        href: "/users/my-ticket",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_ICON */ .cK
    },
    {
        name: "Điểm t\xedch lũy",
        href: "/users/loyalty_points",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .POINT_ACCUMULATING_ICON */ .bv
    },
    {
        name: "Chương tr\xecnh trả thưởng",
        href: "/users/rewards",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .HAND_SHAKE_ICON */ .wp
    }, 
];
var MENUS_SUPPORT = [
    {
        name: "C\xe2u hỏi thường gặp",
        href: "https://thuocsihotro.helpwise.help/",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_ICON */ .RD
    },
    {
        name: "Hotline: 1800 2038",
        href: "tel:+8418002038",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .PHONE_ICON */ .EU
    },
    {
        name: "Li\xean hệ chat",
        href: LINK_DIRECT_TO_MESSENGER,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_0__/* .CONTACT_ICON */ .KX
    }, 
];
var ENUM_PRODUCT_TYPE = {
    KHUYENMAI: "khuyenmai",
    NEW: "new",
    FAV: "fav"
};
var ENUM_SELLER_TYPE = {
    ALL: "all",
    FLAGSHIP: "flagship"
};
var ACCOUNTS_TRIAL = {
    prd: [
        16236,
        59954,
        31217,
        46433,
        24079,
        40543,
        31680,
        33223,
        606,
        63761,
        82295,
        29412,
        3556,
        74843,
        74326,
        14183,
        42320,
        68705,
        51644,
        13344,
        726,
        91787,
        56644,
        52904,
        43409,
        40132,
        22272,
        81345,
        76029,
        46913,
        54056,
        8244,
        3013,
        37592,
        221073,
        79549,
        227444,
        91661,
        62743,
        218228,
        89357,
        244185,
        48845,
        253562,
        73230,
        74027,
        45079,
        4968,
        89768,
        92729,
        234491,
        249365,
        89377,
        55990,
        38097,
        94401,
        225343,
        91230,
        94843,
        82919,
        81372,
        253699,
        226652,
        237691,
        248883,
        227714,
        92730,
        11856,
        244703,
        205792,
        253556,
        60803,
        218616,
        82835,
        226001,
        79342,
        36289,
        68951,
        218511,
        73802,
        11244,
        28393,
        68476,
        270946,
        245254,
        34936,
        31539,
        88356,
        233664,
        226273,
        91487,
        222566,
        82221,
        238730,
        225688,
        235299,
        53784,
        222654,
        46359,
        267038,
        69353,
        80958,
        227446,
        251412,
        230234,
        255311,
        29976,
        47701,
        230086,
        52621,
        31835,
        83101,
        56124,
        223662,
        90539,
        71992,
        248895,
        245519,
        61808,
        253238,
        48727,
        64801,
        91247,
        242995,
        254007,
        224139,
        205065,
        90169,
        206435,
        61136,
        39267,
        91029,
        43805,
        242804,
        64655,
        248894,
        73573,
        62199,
        92335,
        74466,
        37820,
        244195,
        23096,
        25678,
        217377,
        236150,
        77357,
        32791,
        266958,
        243821,
        16236,
        59954,
        31217,
        46433,
        24079,
        40543,
        31680,
        33223,
        606,
        63761,
        82295,
        29412,
        3556,
        74843,
        74326,
        14183,
        42320,
        68705,
        51644,
        13344,
        726,
        91787,
        56644,
        52904,
        43409,
        40132,
        22272,
        81345,
        76029,
        46913,
        54056,
        8244,
        3013,
        37592,
        221073,
        79549,
        227444,
        91661,
        62743,
        218228,
        89357,
        244185,
        48845,
        253562,
        73230,
        74027,
        45079,
        4968,
        89768,
        92729,
        234491,
        249365,
        89377,
        55990,
        38097,
        94401,
        225343,
        91230,
        94843,
        82919,
        81372,
        253699,
        226652,
        237691,
        248883,
        227714,
        92730,
        11856,
        244703,
        205792,
        253556,
        60803,
        218616,
        82835,
        226001,
        79342,
        36289,
        68951,
        218511,
        73802,
        11244,
        28393,
        68476,
        270946,
        245254,
        34936,
        31539,
        88356,
        233664,
        226273,
        91487,
        222566,
        82221,
        238730,
        225688,
        235299,
        53784,
        222654,
        46359,
        267038,
        69353,
        80958,
        227446,
        251412,
        230234,
        255311,
        29976,
        47701,
        230086,
        52621,
        31835,
        83101,
        56124,
        223662,
        90539,
        71992,
        248895,
        245519,
        61808,
        253238,
        48727,
        64801,
        91247,
        242995,
        254007,
        224139,
        205065,
        90169,
        206435,
        61136,
        39267,
        91029,
        43805,
        242804,
        64655,
        248894,
        73573,
        62199,
        92335,
        74466,
        37820,
        244195,
        23096,
        25678,
        217377,
        236150,
        77357,
        32791,
        266958,
        243821,
        247359,
        247884,
        254737,
        260042,
        247657, 
    ],
    stg: [
        2511,
        2871,
        2730
    ]
};
var TagCode = {
    SP: "@SP_",
    DH: "@DH_",
    HOTRO: "@HOTRO_"
};
var tagList = [
    // {
    //   code: TagCode.SP,
    //   image: '/icons/mobile/chat/SP.svg',
    //   title: 'Tag sản phẩm',
    //   guide: `${TagCode.SP}`,
    // },
    {
        code: TagCode.DH,
        image: "/icons/mobile/chat/DH.svg",
        title: "Tag đơn h\xe0ng",
        guide: "".concat(TagCode.DH)
    },
    {
        code: TagCode.HOTRO,
        image: "/icons/mobile/chat/HOTRO.svg",
        title: "Tag phiếu hỗ trợ",
        guide: "".concat(TagCode.HOTRO)
    }, 
];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 89388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QG": function() { return /* binding */ checkTrialSelected; },
/* harmony export */   "Uw": function() { return /* binding */ checkNewUser; }
/* harmony export */ });
/* harmony import */ var constants_data_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76412);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17445);


var checkTrialSelected = function(user) {
    var userSelected = constants_data_mobile__WEBPACK_IMPORTED_MODULE_0__/* .ACCOUNTS_TRIAL */ .wf[ false ? 0 : "stg"] || [];
    return userSelected === null || userSelected === void 0 ? void 0 : userSelected.some(function(element) {
        return element === (user === null || user === void 0 ? void 0 : user.customerID);
    });
};
var checkNewUser = function(createdDate) {
    var TIME_OPEN_TRIAL = "November 24, 2022 00:00:00";
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(TIME_OPEN_TRIAL), new Date(createdDate)) >= 0;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ })

}]);